module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/power-phone-2.f6ad67a0.jpg";